
























































import {Component, PropSync, Watch} from "vue-property-decorator";
import {DateTime} from "luxon";
import {DatePickerWings, FastDateDetailWings, SelectWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {ReportFilter} from "@/store/settings/reports/types";
import BaseFilter from "@/components/Filter/BaseFilter";
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from "@/utils/date-util";
import { getTranslatedParams } from "@/utils/notify-utils";
import { notifyError, notifyWarning } from "@/utils/notify-helper";

@Component({
  components: {
    DatePickerWings,
    FastDateDetailWings,
    SelectWings,
  },
  filters: { dateFilter }
})
export default class ReportsFilter extends BaseFilter<ReportFilter> {
  @PropSync('show') is_show!: boolean;
  @Getter("reportStatusList") statusList: any;
  @Action("getReports") actionGetReports: any;
  @Action("actionLog") actionLog: any;

  defaultFilter():ReportFilter {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      status: null,
      type: 'export'
    }
  }

  created() {
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: 'success',
        object_type: "Report",
        addititional_info: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetReports(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status === 204) {
        notifyWarning()
      }
    } catch(err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err)
    }
  }

  @Watch('defaultFilter', { immediate: true, deep: true })
  onDefaultFilterChange():void {
    this.filter.date_to = this.defaultFilter().date_to
  }
}
